import { Map } from "immutable";

import postsActions from "./actions";

const stateCode = "";
const estimatedBill = {};
const stateFetching = false;
const billCalculating = false;

const initState = new Map({
  stateCode,
  stateFetching,
  billCalculating,
  estimatedBill
});

export default function energyCostCalcReducer(state = initState, action) {
  switch (action.type) {
    case postsActions.FIND_STATE:
      return state.set("stateFetching", true);
    case postsActions.FIND_STATE_SUCCESS:
      return state.set("stateCode", action.response.data.stateCode).set("stateFetching", false);
    case postsActions.FIND_STATE_ERROR:
      return state.set("stateFetching", false);
    case postsActions.GET_ESTIMATED_BILL:
      return state.set("billCalculating", true);
    case postsActions.GET_ESTIMATED_BILL_SUCCESS:
      return state.set("estimatedBill", action.response.data).set("billCalculating", false);
    case postsActions.GET_ESTIMATED_BILL_ERROR:
      return state.set("billCalculating", false);
    default:
      return state;
  }
}
